var map = {
	"./age_of_heroes.png": 7007,
	"./always_american.png": 2064,
	"./always_hot.png": 2069,
	"./always_hot_deluxe.png": 557,
	"./amazon_treasures.png": 7652,
	"./american_poker_2_mob.png": 903,
	"./arctic_treasure.png": 9538,
	"./azteca.png": 6272,
	"./banana_splash.png": 3251,
	"./bananas_go_bahamas.png": 1914,
	"./basketball.png": 6304,
	"./beetlee_mania.png": 5692,
	"./beetlee_mania_deluxe.png": 2963,
	"./bloody_garage.png": 9574,
	"./book_of_ra.png": 4293,
	"./book_of_ra_6-deluxe.png": 1535,
	"./book_of_ra_deluxe.png": 3434,
	"./book_of_strike.png": 9142,
	"./buzkashi.png": 9439,
	"./buzkashi2.png": 9752,
	"./captains_treasure.png": 2740,
	"./cash_tank.png": 746,
	"./cherry_love.png": 8403,
	"./cocktail_football.png": 4545,
	"./cold_spell.png": 762,
	"./columbus.png": 7020,
	"./columbus_deluxe.png": 632,
	"./columbus_warship.png": 3057,
	"./crazy_monkey.png": 4906,
	"./crazy_monkey2.png": 2905,
	"./crazy_of_hockey.png": 9413,
	"./diamond_trio.png": 5284,
	"./diamond_valley.png": 5451,
	"./dirty_money.png": 9976,
	"./dolphins_pearl.png": 7548,
	"./egyptian_experience_deluxe.png": 9202,
	"./emperors_china.png": 251,
	"./endorphina_chance_machine20.png": 3417,
	"./endorphina_chance_machine5.png": 2734,
	"./endorphina_chance_machine5_dice.png": 6633,
	"./endorphina_diamond_chance.png": 3580,
	"./endorphina_gem_blast.png": 787,
	"./endorphina_in_jazz.png": 2367,
	"./endorphina_joker_stoker.png": 5474,
	"./endorphina_solar_eclipse.png": 8332,
	"./endorphina_voodoo.png": 4695,
	"./endorphina_voodoo_dice.png": 3278,
	"./escape.png": 4112,
	"./fairy_land.png": 272,
	"./fairy_queen.png": 553,
	"./faust.png": 322,
	"./flame_dancer.png": 3823,
	"./football.png": 8693,
	"./from_russia.png": 4046,
	"./fruit_cocktail.png": 6878,
	"./fruit_cocktail2.png": 797,
	"./fruit_sensation.png": 1860,
	"./fruits_and_royals.png": 8460,
	"./garage.png": 5848,
	"./gate_of_ra.png": 1620,
	"./gnome.png": 4651,
	"./gold_basketball.png": 1329,
	"./gold_craze_deluxe.png": 6782,
	"./golden_ark.png": 7475,
	"./golden_games.png": 829,
	"./great_blue.png": 3255,
	"./gryphons_gold.png": 1111,
	"./hannibal_deluxe.png": 9794,
	"./haute_couture.png": 2440,
	"./hockey.png": 3836,
	"./holmes_watson_deluxe.png": 9228,
	"./hot_chance-deluxe.png": 2900,
	"./hulk.png": 6635,
	"./hulk2.png": 9093,
	"./illusionist.png": 6710,
	"./inbet_buffalo_spirit_3x3.png": 9555,
	"./inbet_buffalo_spirit_3x3_pull_tabs.png": 5538,
	"./inbet_diamond_rich_life_3x3.png": 6557,
	"./inbet_diamond_rich_life_3x3_pull_tabs.png": 1705,
	"./inbet_haunted_money_3x3.png": 9696,
	"./inbet_haunted_money_3x3_pull_tabs.png": 3054,
	"./inbet_irish_story_3x3.png": 8322,
	"./inbet_irish_story_3x3_pull_tabs.png": 6707,
	"./inbet_irish_story_keno.png": 7075,
	"./irish_luck.png": 4352,
	"./iron_man.png": 4667,
	"./iron_man2.png": 6341,
	"./island2.png": 5034,
	"./jackpot_crown.png": 312,
	"./just_fruits.png": 3653,
	"./just_jewels.png": 4080,
	"./just_jewels_deluxe.png": 9307,
	"./keks.png": 3729,
	"./keno_live.png": 2595,
	"./khodja.png": 1994,
	"./lord_of_the_ocean.png": 6372,
	"./lord_of_warcraft.png": 9711,
	"./lucky_dota.png": 2193,
	"./lucky_drink.png": 612,
	"./lucky_haunter.png": 9296,
	"./lucky_lady_charm-deluxe.png": 7930,
	"./lucky_lady_charm.png": 5191,
	"./lucky_rose.png": 4432,
	"./marco_polo-deluxe.png": 438,
	"./marco_polo.png": 8279,
	"./marco_polo_deluxe.png": 5460,
	"./millenium_3wishes.png": 9594,
	"./millenium_aladdin.png": 8502,
	"./millenium_arabian_delight.png": 803,
	"./millenium_arctic_gold.png": 1753,
	"./millenium_chicago.png": 1831,
	"./millenium_circus_magic.png": 2659,
	"./millenium_dolphins_lagoon.png": 4331,
	"./millenium_fairy_forest.png": 1338,
	"./millenium_flame_jocker.png": 6468,
	"./millenium_fruit_show.png": 5859,
	"./millenium_gnoms_mine.png": 2161,
	"./millenium_hot_strike.png": 3576,
	"./millenium_hotter_ace.png": 6131,
	"./millenium_india_night.png": 9056,
	"./millenium_lucky_menu.png": 6335,
	"./millenium_lucky_saloon.png": 2921,
	"./millenium_masha_and_bear.png": 6502,
	"./millenium_monkey_island.png": 6745,
	"./millenium_pharaohs_artifact.png": 9292,
	"./millenium_rabbit_illusion.png": 2468,
	"./millenium_shaolino.png": 6325,
	"./millenium_sinbad.png": 110,
	"./mystic_secrets.png": 6881,
	"./oliver_bar.png": 7731,
	"./panther_moon.png": 979,
	"./party_games.png": 7606,
	"./penguin_vacation.png": 3969,
	"./pharaohs_ring.png": 9783,
	"./pharaons_gold.png": 5964,
	"./pirate.png": 6252,
	"./quake_mania.png": 2790,
	"./resident.png": 1890,
	"./resident_nfl.png": 4087,
	"./resident_of_nfl.png": 5518,
	"./rock_climber.png": 2035,
	"./rome_and_glory.png": 3540,
	"./roulette_mob.png": 6041,
	"./roulette_with_track_mob.png": 3968,
	"./royal_treasures-deluxe.png": 2984,
	"./royal_treasures.png": 3496,
	"./royal_treasures_deluxe.png": 7510,
	"./safari_heat.png": 4923,
	"./santechnik.png": 2292,
	"./secret_of_egypt_deluxe.png": 8119,
	"./shark_tanks.png": 1419,
	"./sharky.png": 2870,
	"./silver_fox.png": 8748,
	"./sizzling_crown_deluxe.png": 165,
	"./sizzling_eight_deluxe.png": 6005,
	"./sizzling_gems_deluxe.png": 7405,
	"./sizzling_hot7_deluxe.png": 4814,
	"./skazka.png": 1952,
	"./sparta.png": 1115,
	"./starcraft_pearl.png": 3875,
	"./sweet_life.png": 7954,
	"./thai_paradise.png": 9222,
	"./the_discovery.png": 1893,
	"./the_ming_dynasty_deluxe.png": 8937,
	"./the_money_game.png": 2631,
	"./the_money_game_deluxe.png": 8265,
	"./true_love.png": 8644,
	"./world_spirit.png": 2132
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2197;